<template>
  <button class="button button-white" @click="actualize">
    <b-icon icon="repeat" custom-size="mdi-18px"></b-icon>
    <span>{{ title }}</span>
  </button>
</template>

<script>
import axios from "axios";
import { apiUrl } from "@/api/apiUrl.js";
import errors from "@/localize/errors.js";

export default {
  name: "actualizeState",
  props: ["transaction_id"],
  data() {
    return {
      title: "Актуализация статуса",
      loading: false,
    };
  },
  methods: {
    actualize() {
      let params = {
        transaction_id: this.transaction_id,
      };
      let config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      this.loading = true;
      axios
        .post(apiUrl+"transaction/actualize", params, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.$message({
              message: "Статус актуализирован",
              type: "success",
            });
            setTimeout(()=>{
              this.$emit("loadAsyncData")
            }, 500);
          } else {
            this.$message.error(errors[data.error_code]);
          }
          this.loading = false;
        })
        .catch(err => {
          this.$message.error(errors[err.response.data.error_code]);
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>

</style>